import { Reducer } from 'redux';
import { CustomFieldsInterface } from './types';

export const CustomFieldsInitialState: CustomFieldsInterface = {
    isLoadingFields: false,
    isLoadedFields: false,
    collection: null,
    isAddingField: false,
    selectedFieldName: null,
    newField: null,
    visibleSet: null,
    allFields: null,
    recognizedFields: null,
    currentFieldType: '',
};

const reducer: Reducer<CustomFieldsInterface> = (
    state: CustomFieldsInterface = CustomFieldsInitialState,
    action
): CustomFieldsInterface => {
    switch (action.type) {
        case '@@contactfields/FETCH_START':
        case '@@contactfields/FETCH_ERROR':
        case '@@contactfields/FETCH_SUCCESS':
        case '@@contactfields/CREATE_START':
        case '@@contactfields/CREATE_ERROR':
        case '@@contactfields/CREATE_SUCCESS':
        case '@@contactfields/DELETE_SUCCESS':
        case '@@contactfields/SET_CUSTOM_FIELD':
        case '@@contactfields/SET_COLLECTION':
        case '@@contactfields/GET_FIELDS':
        case '@@contactfields/SET_FIELDS':
            return { ...state, ...action.payload };
        case '@@contactfields/SET_CURRENT_FIELD_TYPE':
            return { ...state, currentFieldType: action.payload.currentFieldType };
        default:
            return state;
    }
};

export { reducer as customFields };

export default reducer;
